import { debounce } from "lodash";
import performanceCollection from "@al/performance-collect";
import { customSentryReportIfEnabled } from "@al/next/al-ex";
import { IO, I18nTools, CountryCode, LanguageCode, countryMap } from "@al/base-lib";
import JsCookie from "js-cookie";
// font 形式的字体图标，某些图标在手机上无法显示, 故彩色icon 改用 svg
import "./style/fonts/iconfont2";
import "./style/index.global.scss";

import unauthorizedToLogin from "~/common/utils/unauthorizedToLogin";
import Analytics from "~/common/tracker/analytics";
// import { tracker } from "~/common/tracker";
import DeviceSDK from "~/common/device-sdk";

import { getCookieOpts } from "../common/utils";
import { COOKIE_KEYS_MAP } from "../common/constants";
import { getDefaultLanguageCode, isMobile, getValueFromCookie, setValueToCookie } from "../common/utils/base";

import { actions, reducer } from "./redux";
import { extendsPageConfig } from "./extendsPageConfig";

const asyncInitBrowserData = debounce(
  async (ctx) => {
    // app外
    const deviceId = await DeviceSDK.getDeviceId();
    ctx.deviceId = deviceId;
    // tracker.updateSdkConfig({
    //   behavior: {
    //     v4: {
    //       deviceId: deviceId,
    //     },
    //   },
    // });
  },
  500,
  { leading: true, trailing: false }
);

// 性能监控

const performanceCollectionConfig =
  process.env.BUILD_ENV === "prod"
    ? {
        apiKey: "AIzaSyBt7SLd-WLlPpHQcIBlzOhhIbwIjH5Du6g",
        authDomain: "akulaku-web-1a00b.firebaseapp.com",
        databaseURL: "https://akulaku-web-1a00b.firebaseio.com",
        projectId: "akulaku-web-1a00b",
        storageBucket: "akulaku-web-1a00b.appspot.com",
        messagingSenderId: "778102340676",
        appId: "1:778102340676:web:ce7cb60844b75e6181d011",
      }
    : {
        apiKey: "AIzaSyBkk1nKE_vvCL3ceaUVkLP53HROVK8sSkE",
        authDomain: "akulaku-web-test.firebaseapp.com",
        databaseURL: "https://akulaku-web-test.firebaseio.com",
        projectId: "akulaku-web-test",
        storageBucket: "akulaku-web-test.appspot.com",
        messagingSenderId: "998612602448",
        appId: "1:998612602448:web:2f535e30c406f2d1dc0b55",
        measurementId: "G-FN5QM7B0K8",
      };

if (process.browser) {
  const prometheusEnabled = false;
  const routeNamePrefix = "eu_m_";
  performanceCollection.init({
    config: performanceCollectionConfig,
    env: process.env.BUILD_ENV,
    pageMode: "ssr",
    routeBase: "/mobile",
    routeConfig: {
      "/product/detail": {
        name: `${routeNamePrefix}product_detail`,
        firebase: {
          enabled: true,
        },
        prometheus: {
          enabled: prometheusEnabled,
          extraInfo: {
            businessType: "M站商品详情",
            businessChildType: "M站商品详情",
          },
        },
      },
      "/product/evaluation": {
        name: `${routeNamePrefix}product_evaluation`,
        firebase: {
          enabled: true,
        },
        prometheus: {
          enabled: prometheusEnabled,
          extraInfo: {
            businessType: "M站商品详情",
            businessChildType: "M站商品详情-评价",
          },
        },
      },
    },
    shouldLog: process.env.BUILD_ENV !== "prod",
    shouldReport: process.env.BUILD_ENV !== "local",
  });
}

if (process.browser && !JsCookie.get("deviceType")) {
  if (isMobile()) {
    JsCookie.set("deviceType", "browser");
  } else {
    JsCookie.set("deviceType", "pc");
  }
}

let saIsLogin = false;

export default function global() {
  return {
    // 全局 actions 和 reducer
    redux: {
      actions,
      reducer,
    },
    // 全局语言推导和语言包
    i18n: {
      resolve: (ctx, lifecycleStatus, initialI18nConf) => {
        const req = ctx.req || {};
        const { query } = ctx;
        const cookieLanguageCode = getValueFromCookie(req, COOKIE_KEYS_MAP.LanguageCode);
        const countryInfo = countryMap[query.countryCode];
        // 如果国家和语言不匹配时，清除cookie中的语言
        if (
          query.countryCode &&
          !query.languageCode &&
          countryInfo &&
          cookieLanguageCode &&
          ![countryInfo.languageCode, LanguageCode.en].includes(cookieLanguageCode)
        ) {
          setValueToCookie({ ctx, key: COOKIE_KEYS_MAP.LanguageCode, value: "" });
        }
        // 初始化一些信息
        I18nTools.initI18nNeedInfo({
          COOKIE_KEYS_MAP: {
            CountryCode: COOKIE_KEYS_MAP.CountryCode,
            CountryId: COOKIE_KEYS_MAP.CountryId,
            LanguageCode: COOKIE_KEYS_MAP.LanguageCode,
            LanguageId: COOKIE_KEYS_MAP.LanguageId,
          },
          buildEnv: process.env.BUILD_ENV,
          cookieOptions: getCookieOpts(req),
          defaultCountryCode: CountryCode.ID,
          // 当query及cookie中不存在时才会使用 defaultLanguageCode
          defaultLanguageCode: getDefaultLanguageCode(ctx),
          closeInitSetCookie: query.countryCode ? false : true,
        });
        return I18nTools.resolveI18n(ctx, lifecycleStatus, initialI18nConf);
      },
      //引入全局语言包
      resource: {
        en: require("./i18n/en.json5"),
        de: require("./i18n/de.json5"),
        es: require("./i18n/es.json5"),
        fr: require("./i18n/fr.json5"),
        it: require("./i18n/it.json5"),
        pl: require("./i18n/pl.json5"),
      },
    },
    env: resolveRuntimeEnv,
    // prefetchApi: {
    //   globalUserInfo: {
    //     critical: true,
    //     // url: "/capi/personal/user/login-status/get",
    //     url: "/mapi/personal/user/user-info-detail/get",
    //     method: "post",
    //     type: "JSON",
    //     headers: {
    //       "language-id": "$cookie.languageId",
    //       "country-id": "$cookie.countryId",
    //       "device-type": "$cookie.deviceType||browser",
    //       "channel-id": "4",
    //     },
    //   },
    // },
    convertRawResponseToSiteResponse(propKey, xhrResponse, ctx) {
      return IO.convertAxiosResponseToSizeResponse(
        { success: xhrResponse.success, resOrError: xhrResponse.response },
        ctx
      );
    },
    lifecycle(ctx, result, { isExport }) {
      // server / browser 尽可能早的初始化 io
      if (!isExport && ctx) {
        if (!ctx.scope.io) {
          ctx.scope.io = new IO({
            ctx,
            config: {
              withCredentials: true,
              headers: {
                "Content-Type": "application/json",
                // 设备类型，区分手机浏览器或电脑浏览器
                "device-type": JsCookie.get("deviceType") || "browser",
                // 渠道标识，4表示为M站
                // "channel-id": "4",
                "device-id": ctx.deviceId,
              },
            },
            // 事件
            events: {
              // 添加错误事件回调，一般c端才需要进行捕获错误
              onResponseError(error) {
                if (!error.response || (error.response && error.response.status !== 401)) {
                  const { method, params, url } = error.config;
                  customSentryReportIfEnabled(new Error("response_error"), "io", (scope) => {
                    scope.setExtras({
                      url,
                      lifecycleStatus: ctx.lifecycleStatus ? JSON.stringify(ctx.lifecycleStatus) : "not set",
                      method,
                      params,
                      status: error.response ? error.response.status : undefined,
                      downgrade: typeof window === "undefined" ? "ssr" : window.AL_SSR_DOWNGRADE,
                      time: error.config._ts,
                    });
                  });
                }
              },
            },
          });
        }
        if (!ctx.io) {
          ctx.io = ctx.scope.io;
        }
      }
      if (!saIsLogin && process.browser && ctx && ctx.store && ctx.SA) {
        if (ctx.store.getState().sign.isSign) {
          saIsLogin = true;
          // TODO: 神策登录
          // ctx.SA.login(ctx.store.getState().sign.userDetail.uid);
        }
      }
      if (ctx && !ctx.deviceId) {
        if (process.browser) {
          asyncInitBrowserData(ctx);
        }
      }
    },
    // 扩展 pageConfig 机制，使得业务站点可自己扩展行为
    extendsPageConfig,
  };
}

function resolveRuntimeEnv(ctx, serverEnv) {
  let runtimeEnv;

  // export，无业务环境概念
  if (ctx.lifecycleStatus.isExport) {
    // no stuff
  }

  // server，对仅支持 pre render 的工程来说，仅用于本地 dev
  else if (process.server) {
    runtimeEnv = resolveRuntimeEnvByHostname(ctx.req.hostname);
  }

  // browser，若 server 已指定，以 server 为准；若未指定，从 url 自行推导
  else {
    if (serverEnv && serverEnv.RUNTIME_ENV) {
      runtimeEnv = serverEnv.RUNTIME_ENV;
    } else {
      runtimeEnv = resolveRuntimeEnvByHostname(location.hostname);
    }
  }

  return { RUNTIME_ENV: runtimeEnv };

  function resolveRuntimeEnvByHostname(hostname) {
    if (process.env.RUNTIME_ENV) {
      return process.env.RUNTIME_ENV;
    }
    if (/^sit/.test(hostname)) {
      return "sit";
    } else if (!/^test/.test(hostname) && !(/^localhost/.test(hostname) || /^\d+\.\d+\.\d+\.\d+/.test(hostname))) {
      return "prod";
    } else {
      return "test";
    }
  }
}
